/** Metric box layout — aligned with analyticsGlossary sections. */

export const HERO_METRICS = ["gtv", "netRevenue", "mrr", "paidActiveMembers"];

/** Metrics where an increase is bad (delta colors inverted). */
export const INVERSE_DELTA_METRICS = new Set([
  "churnRate",
  "churnedRevenue",
  "totalRefunded",
  "refundRate",
  "disputeRate",
  "abandonedCheckouts",
  "creatorPayouts",
]);

export const METRIC_SECTIONS = [
  {
    id: "moneyIn",
    titleKey: "mintSpaceSettings.metricSectionMoneyIn",
    metrics: ["gtv", "grossRevenue", "netRevenue"],
  },
  {
    id: "recurringHealth",
    titleKey: "mintSpaceSettings.metricSectionRecurring",
    metrics: ["mrr", "arr", "arpu", "paidActiveMembers", "churnRate", "churnedRevenue"],
  },
  {
    id: "moneyOut",
    titleKey: "mintSpaceSettings.metricSectionMoneyOut",
    metrics: ["totalRefunded", "refundRate", "disputeRate", "creatorPayouts"],
  },
  {
    id: "customers",
    titleKey: "mintSpaceSettings.metricSectionCustomers",
    metrics: ["newUsers", "orders", "netPosition"],
  },
  {
    id: "traffic",
    titleKey: "mintSpaceSettings.metricSectionTraffic",
    metrics: ["traffic", "abandonedCheckouts"],
  },
];

export const METRIC_META = {
  gtv: {
    labelKey: "mintSpaceSettings.metricGtv",
    tipKey: "mintSpaceSettings.tipGtv",
    seriesKey: "gtv",
    glossarySlug: "gtv",
  },
  grossRevenue: {
    labelKey: "mintSpaceSettings.metricGrossRevenue",
    tipKey: "mintSpaceSettings.tipGross",
    seriesKey: "grossRevenue",
    glossarySlug: "gross-revenue",
  },
  netRevenue: {
    labelKey: "mintSpaceSettings.metricNetRevenue",
    tipKey: "mintSpaceSettings.tipRevenueNet",
    seriesKey: "netRevenue",
    glossarySlug: "net-revenue",
  },
  mrr: {
    labelKey: "mintSpaceSettings.kpiMrr",
    tipKey: "mintSpaceSettings.tipMrr",
    glossarySlug: "mrr",
    snapshot: true,
  },
  arr: {
    labelKey: "mintSpaceSettings.kpiArr",
    tipKey: "mintSpaceSettings.tipArr",
    glossarySlug: "mrr",
    snapshot: true,
  },
  arpu: {
    labelKey: "mintSpaceSettings.metricArpu",
    tipKey: "mintSpaceSettings.tipArpu",
    glossarySlug: "arpu",
  },
  paidActiveMembers: {
    labelKey: "mintSpaceSettings.metricPaidActive",
    tipKey: "mintSpaceSettings.tipActiveSubs",
    glossarySlug: "paid-active-members",
    snapshot: true,
  },
  churnRate: {
    labelKey: "mintSpaceSettings.metricChurnRate",
    tipKey: "mintSpaceSettings.tipChurnRate",
    glossarySlug: "churn-rate",
  },
  churnedRevenue: {
    labelKey: "mintSpaceSettings.metricChurnedRevenue",
    tipKey: "mintSpaceSettings.tipChurnedRevenue",
    glossarySlug: "churned-revenue",
  },
  totalRefunded: {
    labelKey: "mintSpaceSettings.metricTotalRefunded",
    tipKey: "mintSpaceSettings.tipRefunded",
    seriesKey: "refunds",
    glossarySlug: "total-refunded",
  },
  refundRate: {
    labelKey: "mintSpaceSettings.metricRefundRate",
    tipKey: "mintSpaceSettings.tipRefundRate",
    glossarySlug: "refund-rate",
  },
  disputeRate: {
    labelKey: "mintSpaceSettings.metricDisputeRate",
    tipKey: "mintSpaceSettings.tipDisputeRate",
    glossarySlug: "dispute-rate",
  },
  newUsers: {
    labelKey: "mintSpaceSettings.metricNewUsers",
    tipKey: "mintSpaceSettings.tipNewUsers",
    glossarySlug: "new-users",
  },
  creatorPayouts: {
    labelKey: "mintSpaceSettings.kpiPayouts",
    tipKey: "mintSpaceSettings.tipPayouts",
    seriesKey: "spend",
  },
  orders: {
    labelKey: "mintSpaceSettings.kpiOrders",
    tipKey: "mintSpaceSettings.tipOrders",
  },
  netPosition: {
    labelKey: "mintSpaceSettings.kpiNet",
    tipKey: "mintSpaceSettings.tipNet",
  },
  traffic: {
    labelKey: "mintSpaceSettings.metricTraffic",
    tipKey: "mintSpaceSettings.tipTraffic",
    seriesKey: "traffic",
    glossarySlug: "traffic",
  },
  abandonedCheckouts: {
    labelKey: "mintSpaceSettings.metricAbandonedCheckouts",
    tipKey: "mintSpaceSettings.tipAbandonedCheckouts",
    glossarySlug: "abandoned-checkouts",
  },
};
